import { Box, SvgIcon, Typography } from '@mui/material';
import {
  Delayed,
  Error,
  Paused,
  Pending,
  Running,
  RunningStatusIcon,
  Success,
} from 'components/SVG';
import { STATUS_TAGS } from 'constants/common';
import React, { CSSProperties } from 'react';

const StatusWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      display='flex'
      alignItems='center'
      gap={2}
      sx={(theme) => ({
        [theme.breakpoints.down('sm')]: {
          alignItems: 'flex-start',
          flexDirection: 'column',
          gap: 1,
        },
        [theme.breakpoints.up('sm')]: {
          flexDirection: 'row',
        },
      })}
    >
      {children}
    </Box>
  );
};

export function showRunsSparkStatus(
  sparkStatus: string | undefined,
  { width, height }: { width?: string; height?: string } = {}
) {
  switch (sparkStatus) {
    case 'all':
      return (
        <StatusWrapper>
          <SvgIcon>
            <RunningStatusIcon />
          </SvgIcon>
          <Typography sx={{ fontSize: '18px', paddingLeft: '15px' }}>
            All Statuses
          </Typography>
        </StatusWrapper>
      );
    case STATUS_TAGS.SUCCESS:
      return (
        <StatusWrapper>
          <Success width={width || '32'} height={width || '32'} />
          <Typography
            sx={{
              color: '#62AF83',
            }}
          >
            {sparkStatus}
          </Typography>
        </StatusWrapper>
      );
    case STATUS_TAGS.ERROR:
      return (
        <StatusWrapper>
          <Error width='32' height='32' />
          <Typography
            sx={{
              color: '#EF5251 ',
            }}
          >
            {sparkStatus}
          </Typography>
        </StatusWrapper>
      );
    case STATUS_TAGS.PENDING:
      return (
        <StatusWrapper>
          <Pending width='32' height='32' />
          <Typography
            sx={{
              color: '#F4821F',
            }}
          >
            {sparkStatus}
          </Typography>
        </StatusWrapper>
      );
    case STATUS_TAGS.RUNNING:
      return (
        <StatusWrapper>
          <Running width='32' height='32' />
          <Typography
            sx={{
              color: '#6268AF',
            }}
          >
            {sparkStatus}
          </Typography>
        </StatusWrapper>
      );
    case STATUS_TAGS.PAUSED:
      return (
        <StatusWrapper>
          <Paused width='32' height='32' />
          <Typography
            sx={{
              color: '#F4821F',
            }}
          >
            {sparkStatus}
          </Typography>
        </StatusWrapper>
      );
    case STATUS_TAGS.DELAYED:
      return (
        <StatusWrapper>
          <Delayed width='32' height='32' />
          <Typography
            sx={{
              color: '#F4821F',
            }}
          >
            {sparkStatus}
          </Typography>
        </StatusWrapper>
      );
    default:
      return <></>;
  }
}
